import styled from "@emotion/styled";
import React from "react";
import { STRINGS } from "../../strings";
import { translate } from "../../translate";
import { AppButton } from "../Generic/AppButton";
import { AppAbstractModal } from "../Generic/AppModal/AppAbstractModal";
import { AppOverlay } from "../Generic/AppOverlay";

export interface PromptClockInAfterHourProps {
  isOpen: boolean;
  onRequestClose: () => void;
  onRequestClockIn: () => void;
}

const PromptClockInAfterHourModal = (props: PromptClockInAfterHourProps) => {
  return (
    <AppOverlay>
      <PromptClockInAfterHourModal.Root isOpen={props.isOpen} onRequestClose={props.onRequestClose}>
        <PromptClockInAfterHourModal.Title>
          {`${translate(STRINGS.LOOKS_LIKE_MORE_THAN)} `}
          <PromptClockInAfterHourModal.TitleRed>
            {translate(STRINGS.ONE_HOUR)}
          </PromptClockInAfterHourModal.TitleRed>
          {` ${translate(STRINGS.PAST_SINCE_THE_VISIT_STARTED)}`}
        </PromptClockInAfterHourModal.Title>
        <PromptClockInAfterHourModal.Message>
          {translate(STRINGS.CLOCKING_IN_NOT_IN_TIME_CAUSES_ISSUES)}
        </PromptClockInAfterHourModal.Message>
        <PromptClockInAfterHourModal.Buttons>
          <AppButton variant="filled" color="primary" onClick={props.onRequestClockIn}>
            {translate(STRINGS.CLOCK_IN_ANYWAY)}
          </AppButton>
          <AppButton variant="link" color="black" onClick={props.onRequestClose}>
            {translate(STRINGS.NO_THANKS)}
          </AppButton>
        </PromptClockInAfterHourModal.Buttons>
      </PromptClockInAfterHourModal.Root>
    </AppOverlay>
  );
};

PromptClockInAfterHourModal.Root = styled(AppAbstractModal)`
  > .container {
    background: url(../assets/clock-warning.svg) no-repeat right top 5%;
    background-color: #fff;
    border-radius: 24px;
    box-sizing: border-box;
    padding: 32px 32px 4px 32px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    text-align: center;
    max-height: 90vh;
  }
`;

PromptClockInAfterHourModal.Title = styled.div`
  font-size: 20px;
  font-weight: 700;
  text-align: left;
  max-width: 70%;
`;

PromptClockInAfterHourModal.Message = styled.div`
  font-size: 14px;
  font-weight: 600;
  margin-top: 8px;
  text-align: left;
  max-width: 70%;
`;

PromptClockInAfterHourModal.Buttons = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
`;
PromptClockInAfterHourModal.TitleRed = styled.span`
  color: var(--danger-color);
  display: inline-block;
`;

export default PromptClockInAfterHourModal;
